/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationGridFilterRequestViewModel } from "../types/CourseRegistrationGridFilterRequestViewModel.ts";
import { eCompanyFilterTypeSchema } from "./eCompanyFilterTypeSchema.ts";
import { eDocumentSelectFilterSchema } from "./eDocumentSelectFilterSchema.ts";

export const courseRegistrationGridFilterRequestViewModelSchema = z.object({
  filter: z.optional(
    z
      .lazy(() => eCompanyFilterTypeSchema)
      .describe("1 = Main | 2 = Company | 3 = All | "),
  ),
  companyId: z
    .number()
    .int()
    .describe(
      "ID da empresa para filtrar as matrículas. Obrigatório quando Filter = Company. Opcional.",
    )
    .nullish(),
  courseRegistrationId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID de uma matrícula específica para filtrar. Use 0 para não filtrar.",
      ),
  ),
  poleId: z
    .number()
    .int()
    .describe(
      "ID do polo. Use -1 para filtrar matrículas sem polo (Pecege Online). Use 0 para não filtrar.",
    )
    .nullish(),
  courseNames: z
    .string()
    .describe(
      "IDs de curso separados por vírgula, podendo conter o prefixo 'GRP' (ex.: 'GRP1,GRP2'). Opcional.",
    )
    .nullish(),
  studentName: z
    .string()
    .describe(
      "Nome do aluno ou IDs de pessoa separados por vírgula com prefixo 'USR' (ex.: 'USR10,USR20'). Opcional.",
    )
    .nullish(),
  status: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status da matrícula para filtrar. Use 0 para retornar todos (exceto PaymentSelection). Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
      ),
  ),
  documents: z.optional(
    z
      .lazy(() => eDocumentSelectFilterSchema)
      .describe("0 = All | 1 = WithDocuments | 2 = WithoutDocuments | "),
  ),
  documentStartDate: z
    .string()
    .datetime()
    .describe(
      "Data de início do intervalo para filtro por data do documento (formato: yyyy-MM-dd). Opcional.",
    )
    .nullish(),
  documentEndDate: z
    .string()
    .datetime()
    .describe(
      "Data de término do intervalo para filtro por data do documento (formato: yyyy-MM-dd). Opcional.",
    )
    .nullish(),
  email: z
    .string()
    .describe("E-mail do aluno para filtrar as matrículas. Opcional.")
    .nullish(),
  cpf: z
    .string()
    .describe(
      "CPF do aluno, com ou sem máscara, para filtrar as matrículas. Opcional.",
    )
    .nullish(),
  page: z.optional(
    z.number().int().describe("Número da página para paginação. Padrão: 1."),
  ),
  pageSize: z.optional(
    z
      .number()
      .int()
      .describe("Quantidade de registros por página. Padrão: 20."),
  ),
}) as unknown as ToZod<CourseRegistrationGridFilterRequestViewModel>;
